/**
 * Remove-stop dialog (modal). Shown when removing a stop that no other
 * orientation uses (usage <= 1), so unlinking it here would leave it orphaned.
 * Offers a three-way choice: delete the step entirely, keep it for future reuse
 * (unlink only), or cancel. When the step is still used elsewhere the caller
 * unlinks silently and never opens this dialog.
 */
import { Icons } from 'turbotwin-sdk/icons';
import { Icon } from '../Icon';

type Props = {
  stopName: string;
  onDelete: () => void;
  onKeep: () => void;
  onCancel: () => void;
};

export function RemoveStopDialog({ stopName, onDelete, onKeep, onCancel }: Props) {
  return (
    <div className="oe-modal-bd" onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="oe-modal" style={{ maxWidth: 460 }}>
        <div className="oe-modal-head">
          <h2>Remove "{stopName}"</h2>
          <button className="oe-btn ghost sm" aria-label="Close" onClick={onCancel}><Icon of={Icons.action.remove} size={14} /></button>
        </div>
        <div className="oe-modal-body">
          <p style={{ margin: 0 }}>
            No other orientation uses this stop. Delete it permanently, or keep it
            so you can reuse it later from "Add existing".
          </p>
        </div>
        <div className="oe-modal-foot">
          <button className="oe-btn" onClick={onCancel}>Cancel</button>
          <button className="oe-btn" onClick={onKeep}>Keep for future use</button>
          <button className="oe-btn danger" onClick={onDelete}>Delete permanently</button>
        </div>
      </div>
    </div>
  );
}
